module.exports = __webpack_public_path__ + "static/media/Banner_3.d38e78e4.jpg";